/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_MarkersInputs */



/**
* | output |
* | --- |
* | "Project Markers" |
*
* @param {Project_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_markers = /** @type {((inputs?: Project_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marqueurs du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektmarkierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indicatori di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Маркеры проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトマーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores de projeto")
	return /** @type {LocalizedString} */ ("Project Markers")
});